import React from 'react';
import { PMenuIconProps, useMenuIcon } from './useMenuIcon';

export const PublishNewsIco: React.FC<PMenuIconProps> = (props) => {
  const { classes, currentColor } = useMenuIcon(props);
  return (
    <svg
      className={classes.ico}
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M23.447 14.6249C22.7101 14.6249 22.1049 15.2301 22.1049 15.967V22.309C22.1049 23.4142 21.2102 24.3353 20.0786 24.3353H7.71029C6.60504 24.3353 5.68395 23.4407 5.68395 22.309L5.68413 9.9144C5.68413 8.80915 6.57881 7.88806 7.71047 7.88806H14.0525C14.7893 7.88806 15.3946 7.28286 15.3946 6.54602C15.3946 5.80919 14.7893 5.20398 14.0525 5.20398H7.71047C5.10519 5.20398 3 7.30926 3 9.91445V22.309C3 24.9143 5.10529 27.0195 7.71047 27.0195H20.1051C22.7104 27.0195 24.8155 24.9142 24.8155 22.309V15.967C24.7893 15.2302 24.2103 14.6248 23.4473 14.6248L23.447 14.6249Z"
        fill={currentColor}
      />
      <path
        d="M24.6031 9.28293L20.7347 5.41455L12.4453 13.7039L16.3137 17.5459L24.6031 9.28293Z"
        fill={currentColor}
      />
      <path
        d="M27.7616 4.94084L25.0774 2.25662C24.7352 1.91446 24.209 1.91446 23.8932 2.25662L22.2617 3.88813L26.1301 7.75651L27.7616 6.12499C28.0773 5.80926 28.0773 5.25658 27.7616 4.94084Z"
        fill={currentColor}
      />
      <path
        d="M9.79107 16.3619C9.65946 16.4935 9.58052 16.6776 9.55427 16.8619L9.18587 19.9146C9.13318 20.4408 9.58052 20.9146 10.107 20.8357L13.1596 20.4673C13.3439 20.441 13.528 20.3621 13.6597 20.2305L14.8176 19.0726L10.949 15.204L9.79107 16.3619Z"
        fill={currentColor}
      />
    </svg>
  );
};
